import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Calendar, Clock, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SIGNUP_URL } from "../lib/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    axios.get(`${API}/blogs/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setErr("Article not found."))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="max-w-3xl mx-auto px-4 py-20 text-slate-500" data-testid="blog-loading">Loading…</div>;
  if (err || !post) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-20" data-testid="blog-not-found">
        <p className="text-slate-600">{err || "Article not found."}</p>
        <Link to="/blogs" className="text-[#FF6B00] font-semibold mt-4 inline-block">← Back to blog</Link>
      </div>
    );
  }

  return (
    <article className="bg-white" data-testid="blog-detail-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-6">
        <Link to="/blogs" className="inline-flex items-center gap-1 text-sm text-slate-600 hover:text-[#FF6B00]" data-testid="back-to-blogs">
          <ArrowLeft size={14} /> Back to blog
        </Link>
      </div>
      <header className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-8">
        <div className="flex items-center gap-4 text-xs text-slate-500">
          <span className="inline-flex items-center gap-1"><Calendar size={12} /> {new Date(post.published_at).toLocaleDateString("en-CA", { year: "numeric", month: "short", day: "numeric" })}</span>
          <span className="inline-flex items-center gap-1"><Clock size={12} /> {post.read_minutes} min read</span>
        </div>
        <h1 className="font-display text-3xl sm:text-5xl font-bold text-[#0B192C] mt-3 tracking-tight" data-testid="blog-title">{post.title}</h1>
        <p className="mt-4 text-lg text-slate-600">{post.excerpt}</p>
      </header>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="aspect-[16/8] rounded-3xl overflow-hidden bg-slate-100">
          <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose-blog" dangerouslySetInnerHTML={{ __html: post.content_html }} />
        <div className="mt-14 rounded-2xl bg-slate-50 p-8 text-center">
          <h3 className="font-display text-xl font-bold text-[#0B192C]">Try CashPark today</h3>
          <p className="mt-2 text-sm text-slate-600">Live NGN↔CAD rate, transparent margin, fast delivery.</p>
          <a href={SIGNUP_URL} target="_blank" rel="noopener noreferrer" data-testid="blog-cta-signup">
            <Button className="mt-5 rounded-full bg-[#FF6B00] hover:bg-[#E65C00] h-11 px-6 font-semibold">Sign Up</Button>
          </a>
        </div>
      </div>
    </article>
  );
}
